// =============================================================================
// Clothing Try-On — option presets
// =============================================================================

export const ENVIRONMENTS = [
  { value: "studio_white", title: "Studio (White)", description: "Clean white backdrop" },
  { value: "studio_dark", title: "Studio (Dark)", description: "Charcoal, dramatic" },
  { value: "beach", title: "Beach", description: "Golden hour, sand" },
  { value: "urban", title: "Urban Street", description: "City sidewalk" },
  { value: "garden", title: "Garden", description: "Lush, dappled light" },
  { value: "cafe", title: "Cafe Terrace", description: "Warm ambiance" },
  { value: "office", title: "Office", description: "Window light" },
  { value: "rooftop", title: "Rooftop", description: "Skyline backdrop" },
  { value: "gym", title: "Gym", description: "Modern interior" },
  { value: "luxury_hotel", title: "Luxury Hotel", description: "Warm ambient" },
  { value: "street_night", title: "Street (Night)", description: "Neon reflections" },
  { value: "park", title: "Park", description: "Natural daylight" },
  { value: "mall", title: "Mall", description: "Bright retail" },
  { value: "runway", title: "Runway", description: "Fashion catwalk" },
  { value: "custom", title: "Custom (Upload)", description: "Your own photo" },
  { value: "anything", title: "Surprise Me", description: "AI picks the best" },
];

export const RESOLUTIONS = [
  { value: "1K", title: "1K", description: "Fast preview" },
  { value: "2K", title: "2K", description: "Standard" },
  { value: "4K", title: "4K", description: "Max detail" },
];

export const ASPECT_RATIOS = [
  { value: "9:16", title: "Portrait" },
  { value: "1:1", title: "Square" },
  { value: "16:9", title: "Landscape" },
];

export const ACCESSORIES = [
  { value: "none", title: "None", description: "Garment only" },
  { value: "matching", title: "Matching Set", description: "Handbag, jewelry, watch, shoes" },
];

const POSE_CDN = "https://cdn.fluxuro.ai/static/studio/clothing-try-on/pose";
export const POSES = [
  { value: "anything", title: "Surprise Me", description: "AI picks best pose for the garment", image_url: `${POSE_CDN}/suprise_me.webp` },
  { value: "standing_relaxed", title: "Standing Relaxed", description: "Natural stance", image_url: `${POSE_CDN}/standing_relaxed_pose.webp` },
  { value: "hands_on_hips", title: "Hands on Hips", description: "Confident", image_url: `${POSE_CDN}/hands_on_hips_pose.webp` },
  { value: "arms_crossed", title: "Arms Crossed", description: "Strong, grounded", image_url: `${POSE_CDN}/arms_crossed_pose.webp` },
  { value: "hand_in_hair", title: "Hand in Hair", description: "Editorial", image_url: `${POSE_CDN}/hand_in_hair_pose.webp` },
  { value: "over_shoulder", title: "Over Shoulder", description: "Looking back", image_url: `${POSE_CDN}/over_shoulder_pose.webp` },
  { value: "hand_in_pocket", title: "Hand in Pocket", description: "Casual", image_url: `${POSE_CDN}/hand_in_pocket_pose.webp` },
  { value: "leaning", title: "Leaning", description: "Against a wall", image_url: `${POSE_CDN}/leaning_pose.webp` },
  { value: "walking_toward", title: "Walking Toward", description: "Mid-stride", image_url: `${POSE_CDN}/walking_toward_pose.webp` },
  { value: "runway_walk", title: "Runway Walk", description: "Catwalk", image_url: `${POSE_CDN}/runway_walk_pose.webp` },
  { value: "twirling", title: "Twirling", description: "Best for dresses", image_url: `${POSE_CDN}/twirling_pose.webp` },
  { value: "sitting_stool", title: "Sitting (Stool)", description: "High stool", image_url: `${POSE_CDN}/sitting_stool_pose.webp` },
  { value: "sitting_floor", title: "Sitting (Floor)", description: "On the ground", image_url: `${POSE_CDN}/sitting_floor_pose.webp` },
];

// Character Creator workflow ID — used to fetch the client's generated models
export const CHARACTER_CREATOR_WORKFLOW_ID = "1fd70019-eb4d-482f-9611-5f0fc45b2dcc";
